import { gql } from '@apollo/client';
import { DEVICE_FRAGMENT } from '@/entities/device/@x/study';
import DIAGNOSIS_FRAGMENT from '../fragments/diagnosisFragment';
import PATIENT_FRAGMENT from '../fragments/patientFragment';

const CLINIC_STUDIES_QUERY = gql`
  query clinicStudies($filter: ClinicStudyFilterInput, $limit: Int) {
    clinicStudies(filter: $filter, limit: $limit) {
      id
      friendlyId
      externalSource {
        provider
        externalId
      }
      deviceType
      # isExternalDevice
      pendingCommand
      info {
        patient {
          ...PatientFragment
        }
        interprettingPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
        referringPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
        diagnosis {
          ...DiagnosisFragment
        }
        followOnStudy {
          studyType
          reportDueDate
        }
      }
      start
      stop
      studyType
      status
      referenceCode
      sentReferenceCodeAt
      reportDueDate
      timezone
      studyTimeOffset
      patientFirstSyncDeviceAt
      initialDurationOfStudy
      ecgUploadProgress
      rma
      artifact {
        date
        resolvedAt
        percentage
        lastIssueFound
        commonIssueFound
      }
      lastStudyHistory {
        time
        status
      }
      hasArtifactReport
      linkedStudies {
        id
        patientFirstSyncDeviceAt
      }
      facility {
        id
        name
        timezone
        contact {
          country
        }
        status
        enableLiveECGStream
      }
      device {
        ...DeviceFragment
      }
      initDuration
      lastEvaluationEvent {
        id
        createdAt
        start
        stripImgs
      }
      biofluxDirect {
        status
        id
        senderInformation {
          latestLabel {
            transaction {
              trackingStatus
            }
          }
        }
        recipientInformation {
          latestLabel {
            transaction {
              trackingStatus
            }
          }
        }
      }
      isTest
      ecgDetail
      uploadStatus
      isStopping
      patientPaired
      orderNumber
      isAborting
      isDeviceAssignmentPending
      initiatedTime
    }
  }

  ${DEVICE_FRAGMENT}
  ${PATIENT_FRAGMENT}
  ${DIAGNOSIS_FRAGMENT}
`;

export default CLINIC_STUDIES_QUERY;
